import React from "react";
import { useSelector } from "react-redux";

const Steps = () => {
  const { step } = useSelector((state) => state.user);
  const steps = ["step 1", "step 2", "step 3"];
  return (
    <>
      <div className="steps-counter-container bg-white rounded border p-2 my-4">
        {steps.map((item, index) => (
          <div
            key={index}
            className={`step-button ${step > index ? "active" : ""}`}
          >
            {item}
          </div>
        ))}
      </div>
    </>
  );
};

export default Steps;
